import React, { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Button from '@empiriecom/module-components/Button';
import getIcon from '@empiriecom/module-components/utils/getIcon';
import config from '@/config';
import { Rating } from '@/src/interfaces/Rating';

const PagingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.75rem;
`;

const PagingButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 16rem;
  height: 2.5rem;
  padding: 0.5rem 1.25rem;
  &&.loading svg {
    display: none;
  }
`;

const MessageWrapper = styled.div`
  font-size: 0.825rem;
  margin-right: 0.5rem;
`;

const ProgressWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ProgressCount = styled.div`
  margin-bottom: 0.75rem;
`;

const ProgressBar = styled.div<{ progressSize: number }>`
  width: 13.25rem;
  height: 2px;
  background-image: ${({ progressSize }) =>
    `linear-gradient(90deg, #444 0%, #444 ${progressSize}%, #d8d8d8 ${progressSize}%, #d8d8d8 100%);`};
`;

interface RatingsListPagingProps {
  response: Rating;
  isLoading: boolean;
  onPagingClick: () => void;
}

export const RatingsListPaging: FunctionComponent<RatingsListPagingProps> = ({
  response,
  isLoading,
  onPagingClick,
}): ReactElement => {
  const LoadReload = getIcon('LoadReload');
  return (
    <>
      <ProgressWrapper data-testid="ratings-list-paging">
        <ProgressCount>
          <FormattedMessage
            id="customer-ratings.paging.count.label"
            defaultMessage="Du hast {current} von {total} Bewertungen gesehen"
            values={{
              current:
                response.paging.currentPage *
                  parseInt(config.customerRatings.values.pagingCount, 10) <=
                response.product.reviewCountFiltered
                  ? response.paging.currentPage *
                    parseInt(config.customerRatings.values.pagingCount, 10)
                  : response.product.reviewCountFiltered,
              total: response.product.reviewCountFiltered,
            }}
          />
        </ProgressCount>
        <ProgressBar
          progressSize={Math.floor(
            (100 / response.product.reviewCountFiltered) *
              (response.paging.currentPage *
                parseInt(config.customerRatings.values.pagingCount, 10)),
          )}
        />
      </ProgressWrapper>
      {response.product.reviewCountFiltered >
        parseInt(config.customerRatings.values.pagingCount, 10) && (
        <PagingWrapper>
          <PagingButton
            className={isLoading ? 'loading' : ''}
            layout="default"
            uppercase={false}
            onClick={onPagingClick}
            disabled={isLoading}
            data-testid="ratings-list-paging-button"
          >
            <MessageWrapper>
              <FormattedMessage
                id="customer-ratings.paging.load-more"
                defaultMessage="Mehr Bewertungen anzeigen"
              />
            </MessageWrapper>
            <LoadReload size="1.5rem" />
          </PagingButton>
        </PagingWrapper>
      )}
    </>
  );
};

export default RatingsListPaging;
